import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M6.5 2c-1.6569 0-3 1.3432-3 3v14c0 1.6569 1.3431 3 3 3h11c1.6569 0 3-1.3431 3-3V8.3513a3 3 0 0 0-1.0044-2.24L15.7339 2.76A3 3 0 0 0 13.7383 2zm-1 3c0-.5523.4477-1 1-1h6v2.5c0 1.1046.8954 2 2 2h4V19c0 .5523-.4477 1-1 1h-11c-.5523 0-1-.4477-1-1zm11.4253 1.5L14.5 4.3393V6.5z",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#fff",
        d: "M2 11c0-1.1046.8954-2 2-2h16c1.1046 0 2 .8954 2 2v6c0 1.1046-.8954 2-2 2H4c-1.1046 0-2-.8954-2-2z"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M20 11H4v6h16zM4 9c-1.1046 0-2 .8954-2 2v6c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2v-6c0-1.1046-.8954-2-2-2z",
        clipRule: "evenodd"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.3575 11.4857c.2841.4735.1306 1.0878-.343 1.3719l-1.0708.6426 1.0708.6425c.4736.2841.6271.8984.343 1.3719-.2842.4736-.8984.6272-1.372.343l-2.5-1.5a1 1 0 0 1 0-1.7149l2.5-1.5c.4736-.2842 1.0878-.1306 1.372.343m3.7426.7142c.4418.3313.5313.9581.2 1.4l-1.5 2c-.3314.4418-.9582.5313-1.4.2-.4419-.3314-.5314-.9582-.2-1.4l1.5-2c.3313-.4419.9581-.5314 1.4-.2m1.3854 2.4423c-.4736.2841-.6271.8984-.343 1.372.2842.4735.8984.6271 1.372.343l2.5-1.5a1.0002 1.0002 0 0 0 0-1.715l-2.5-1.5c-.4736-.2842-1.0878-.1306-1.372.343-.2841.4735-.1306 1.0878.343 1.372l1.0708.6425z",
        clipRule: "evenodd"
    }, "3")
], "CreativeHTML", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
